module.exports = __webpack_public_path__ + "img/nrw85.7d9b5a91.png";